import React from "react";
import cn from "classnames";
import MPOzonIcon from "@assets/icons/marketplaces/Ozon.svg?react";
import MPWbIcon from "@assets/icons/marketplaces/Wildberries.svg?react";
import MPYandexIcon from "@assets/icons/marketplaces/YandexMarket.svg?react";
import MPAliExpressIcon from "@assets/icons/marketplaces/AliExpress.svg?react";
import styles from './Marketplace.module.scss';

interface MarketplaceProps {
  name: string;
  className?: string;
  size?: 'large' | 'small';
}

function getMarketplaceIcon(id: string) {
  const icons: Record<string, React.FunctionComponent<React.SVGAttributes<SVGElement>>> = {
    Ozon: MPOzonIcon,
    Yandex: MPYandexIcon,
    Wildberries: MPWbIcon,
    Aliexpress: MPAliExpressIcon,
  }

  return icons[id] ?? null;
}

export const Marketplace: React.FC<MarketplaceProps> = ({
  name,
  className,
  size,
}) => {
  const Icon = getMarketplaceIcon(name);

  if (!Icon) {
    console.warn("Неизвестный маркетплейс", name);
    return null;
  }

  return (
    <Icon
      className={cn(
        className,
        styles.marketplace,
        size === "small" && styles.small,
      )}
    />
  );
};
